/**
 * Created by comoon on 1/26/16.
 */

var React = require('react');

var ReactDOM = require('react-dom');

var moment = require('moment');

var _ = require('underscore');

var $ = require('jquery');

var ALikeStore = require("../store/ALikeStore");

var Dispatcher = require("../Dispatcher");

var {ActionConstants, ElementConstants, EventConstants} = require("../Constants");

var {object2class} = require("../util/clazz");

var DATE_FORMAT = "YYYY-MM-DD";

var DATE_MONTH = "YYYY年MMM";

var MONTH_HOLDER = 'months';

var DAY_HOLDER = 'days';

var MONTH_FORMAT = 'MMM';


var CalendarChooser = React.createClass({
    displayName: "CalendarChooser",
    getInitialState(){
        var selected = this.props.selected;
        var current = moment(selected).startOf('month');
        return {
            current
        };
    },
    handle_move2previous(){
        var current = this.state.current;

        current = moment(current).add(-1, 'months');

        this.setState({current});
    },
    handle_move2next(){

        var current = this.state.current;

        current = moment(current).add(1, 'months');

        this.setState({current});
    },
    render(){
        var self = this;
        var props = this.props;
        var selected = props.selected;
        var defaultStart = props.defaultStart;
        var selectedDateString = defaultStart ? "YYYY-MM-DD" : moment(selected).format(DATE_FORMAT);
        var current = this.state.current;
        var from = moment(current).add(0 - current.day(), DAY_HOLDER);
        var daysArray = [];
        var showDayTxt = props.showDayTxt || false;

        var trip = ALikeStore.get_tripBasicInfo();
        var chatId  = trip.chatId || 0;
        var chatUser  = trip.chatUser || 0;
        var dataId = chatId ? chatId : chatUser;


        _.times(6, function (week) {
            var weekArray = (
                <tr className="week" key={week}>
                    {
                        _.map(_.range(0, 7), function (day,index) {
                            var date = moment(from).add(week * 7 + day, DAY_HOLDER);
                            var dayString = date.format("D");
                            var currentMonth = (current.month() === date.month());
                            var selectable = true;
                            if (selectable && props.min && date.isBefore(props.min)) {
                                selectable = false;
                            }
                            if (selectable && props.max && date.isAfter(props.max)) {
                                selectable = false;
                            }
                            var dayTxt = showDayTxt && currentMonth && selectable? (
                                <span className="dayTxt" key={index}>实时计价</span>
                            ):null

                            var className = object2class({
                                'day': true,
                                'current-month': currentMonth,
                                'selected': defaultStart ? false : date.isSame(selected),
                                'valid': selectable
                            });
                            return (
                                <td className={className} key={day}
                                    onClick={e=>selectable && self.props.onSelect(date)}>
                                    {dayString}
                                    {dayTxt}
                                </td>
                            );
                        })
                    }
                </tr>
            );

            daysArray.push(weekArray);
        });
        var previousMonth = moment(current).add(-1, MONTH_HOLDER);
        var nextMonth = moment(current).add(1, MONTH_HOLDER);
        var previousAble = true;
        var nextAble = true;
        if (previousAble && props.min && moment(previousMonth).add(1, MONTH_HOLDER).add(-1, DAY_HOLDER).isBefore(props.min)) {
            previousAble = false;
        }
        if (nextAble && props.max && nextMonth.isAfter(props.max)) {
            nextAble = false;
        }
        var previousMonthClazz = object2class({
            'previous-month': true,
            'disabled': !previousAble
        });
        var nextMonthClazz = object2class({
            'next-month': true,
            'disabled': !nextAble
        });
        var titlePosition = props.titlePosition || "top";
        var dayNote = props.dayNote ? (
                <div className="dayNote">
                    *所有日期均可在线实时计价,也可以 <a href="javascript:void(0)" className="webim-online-click tl-im" data-id={dataId}> 在线咨询 </a>更多计价细节
                </div>
            ):null;
        var title  = (
            <div className="chooser-title">
                <div className="title">
                    {props.title}
                </div>
                {dayNote}

                <div className="selected">已选择<span className="date">{selectedDateString}</span></div>
            </div>
        )
        return (
            <div className="comoon-calendar-chooser">
                {
                    titlePosition === 'top' ? (

                    title

                    ):null
                }
                <div className="chooser-switcher">
                    <div className={previousMonthClazz}
                         onClick={previousAble ? this.handle_move2previous : null}>
                        <i className="icon-calendar-arr-s-lg"/>&nbsp;&nbsp;
                        {moment(current).add(-1, MONTH_HOLDER).format(MONTH_FORMAT)}
                    </div>
                    <div className={nextMonthClazz}
                         onClick={nextAble ? this.handle_move2next: null}>
                        {moment(current).add(1, MONTH_HOLDER).format(MONTH_FORMAT)}&nbsp;&nbsp;
                        <i className="icon-calendar-arr-s-rg"/>
                    </div>
                        <span className="current-year-month">
                            {moment(current).format(DATE_MONTH)}
                        </span>
                </div>
                <table className="calendar-table">
                    <thead>
                    <tr className="week-header">
                        <th className="weekend">周日</th>
                        <th>周一</th>
                        <th>周二</th>
                        <th>周三</th>
                        <th>周四</th>
                        <th>周五</th>
                        <th className="weekend">周六</th>
                    </tr>
                    </thead>
                    <tbody>
                    {daysArray}
                    </tbody>
                </table>
                {
                    titlePosition === 'bottom' ? (

                        title

                    ):null
                }
            </div>
        );
    }
});

module.exports = React.createClass({
    displayName: "Calendar",
    statics: {
        CalendarChooser
    },
    getInitialState(){

        var props = this.props;

        var selected = props.selected || props.min || +new Date();

        selected = moment(selected).startOf('day');

        return {
            selected,
            open: false
        }
    },
    componentDidMount(){

        var self = this;

        var domNode = ReactDOM.findDOMNode(self).firstChild;
        //domNode = $(domNode).find(".comoon-calendar-holder")[0];

        self.__toggleChooserHolder = function (event) {

            var holderInstance = $(event.target).closest(".comoon-calendar-holder");

            if (holderInstance.length === 0) {

                self.setState({open: false});

                return;
            }

            if (!self.__chooserHolder) {

                self.setState({open: false});

                return;
            }

            if ((holderInstance[0] !== domNode) && (self.__chooserHolder[0] !== holderInstance[0])) {

                self.setState({open: false});
            }
        };

        $("body").on("click", self.__toggleChooserHolder);

        this.show_calenderPanel();
    },
    componentWillMount(){

        ALikeStore.on(EventConstants.ACTION_SELECTED_CALEANDAR_STARTDATE, this.on_selectedStartDate);
    },
    componentWillUnmount(){

        ALikeStore.off(EventConstants.ACTION_SELECTED_CALEANDAR_STARTDATE, this.on_selectedStartDate);
        var self = this;

        $("body").off("click", self.__toggleChooserHolder);

        self.__toggleChooserHolder = null;

        delete self.__toggleChooserHolder;
    },

    componentDidUpdate(){
        var self = this;
        var props = self.props;
        var open = this.state.open;
        var min = props.min ? moment(props.min).startOf('day') : null;
        var max = props.max ? moment(props.max).startOf('day') : null;
        var win = $(window);
        var showPanel = this.props.showPanel || false;
        if(showPanel){
            return;
        }
        if (open) {
            if (!self.__chooserHolder) {
                var chooserHolder = self.__chooserHolder = $("<div class='comoon-calendar-holder'></div>");
                chooserHolder.css("position", 'absolute').css("z-index", 10000)
                    .appendTo($("body"));
                var chooser = (<CalendarChooser {...this.props} min={min} max={max} onSelect={this.handle_select}
                                                                selected={self.state.selected}/>);
                ReactDOM.render(chooser, chooserHolder[0]);
                var triggerEl = $(ReactDOM.findDOMNode(self));
                var quoteContainer = $(".quote-container");
                self.__repositonChooser = function repositonChooser() {

                    var triggerOffset = triggerEl.offset();
                    var quoteContainerOffset = quoteContainer.offset();
                    var chooserHolderWidth = triggerEl.outerWidth()>300 ? triggerEl.outerWidth()-10 : chooserHolder.outerWidth();

                    chooserHolder.css('top', triggerOffset.top + triggerEl.height()).css('left', quoteContainerOffset.left+(quoteContainer.width()-chooserHolderWidth)/2);

                    if (self.props.auto) {
                        if (triggerOffset.left < chooserHolder.width()) {
                            chooserHolder.css('top', triggerOffset.top + triggerEl.height()).css("left", quoteContainerOffset.left+(quoteContainer.width()-chooserHolderWidth)/2);
                            var triggerWidth = triggerEl.outerWidth();
                            if (triggerWidth > 300) {
                                var chooserEl = chooserHolder.children().first();
                                chooserEl.outerWidth(triggerWidth);
                                var day = chooserEl.find("td.day");
                                day.height(day.width());
                            }
                        }
                    }
                };
                self.__repositonChooser();
                win.on('resize', self.__repositonChooser);
                win.on('scroll', self.__repositonChooser);
            }
        } else {
            if (self.__chooserHolder) {
                win.off('resize', self.__repositonChooser);
                win.off('scroll', self.__repositonChooser);
                ReactDOM.unmountComponentAtNode(self.__chooserHolder[0]);
                self.__chooserHolder.remove();
                self.__chooserHolder = null;
                delete self.__chooserHolder;
                self.__repositonChooser = null;
                delete self.__repositonChooser;
            }
        }
    },

    componentWillReceiveProps(nextProps){


        if (nextProps.selected) {

            var selected = moment(nextProps.selected).startOf('day');

            this.setState({selected});
        }
    },
    on_selectedStartDate(){
        var self = this;
        var showPanel = this.props.showPanel || false;
        var startData = ALikeStore.get_selectedStartDate();
        var selected = startData.selected;

        this.setState({

            selected: selected,
            open: false
        },function(){

            self.show_calenderPanel();
        });

        this.props.onSelect({selected: selected, date: selected.toDate(), string: selected.format(DATE_FORMAT)});

    },
    handle_toggleChooser(){

        var open = !this.state.open;

        this.setState({open});
    },
    handle_select(selected){
        var showPanel = this.props.showPanel || false;

        var data = {
            selected: selected,
            showPanel: showPanel
        }

        this.setState({open: false, selected},function(){
            Dispatcher.dispatch({type: ActionConstants.SELECTED_CALEANDAR_STARTDATE, data});
        });

        this.props.onSelect({selected: selected, date: selected.toDate(), string: selected.format(DATE_FORMAT), showPanel: showPanel});

    },

    render_default(){



        var state = this.state;
        var selected = state.selected;
        var defaultStart = this.props.defaultStart;
        var selectedDateString = defaultStart ? "YYYY-MM-DD" : moment(selected).format(DATE_FORMAT);
        var calendarInputClazz = object2class({
            'comoon-calendar': true,
            'comoon-calendar-holder': true,
            'open': state.open,
            'passed': this.props.className
        });
        return (
            <span className={calendarInputClazz}
                  onClick={this.handle_toggleChooser}>
                {selectedDateString}
                <i className="icon-calendar-calendar-gary"></i>
            </span>
        );
    },
    show_calenderPanel(){
        var self = this;
        var props = self.props;
        var showPanel = props.showPanel || false;
        var open = this.state.open;
        var min = props.min ? moment(props.min).startOf('day') : null;
        var max = props.max ? moment(props.max).startOf('day') : null;
        var dayNote = props.dayNote || false;
        var titlePosition = props.titlePosition || 'top';
        if(!showPanel){
            return;
        }
        if (self.__panelHolder) {
            ReactDOM.unmountComponentAtNode(self.__panelHolder[0]);
            self.__panelHolder.remove();
            self.__panelHolder = null;
            delete self.__panelHolder;
        }
        if(!self.__panelHolder){
            var panelCalendar = self.__panelHolder = $("<div class='comoon-calendar-holder showPanel'></div>")
            $(".panelCalendarWarp").html(panelCalendar)
            var chooser = (<CalendarChooser {...this.props} min={min} max={max}
                                                            onSelect={this.handle_select}
                                                            selected={self.state.selected}
                                                            titlePosition={titlePosition}
                                                            dayNote={dayNote}
                                                            showDayTxt={true} />);

            ReactDOM.render(chooser, panelCalendar[0]);
        }
    },
    render_calenderPanel(){
        return (
            <div></div>
        )
    },
    render(){
        var self = this;
        var props = self.props;
        var showPanel = props.showPanel || false;
        return(
            <div>
                {
                    ! showPanel ? (
                        this.render_default()
                    ):(
                        this.render_calenderPanel()
                    )
                }
            </div>
        )
    }
});
 


/** WEBPACK FOOTER **
 ** ./script/cutil/Calendar.jsx
 **/